<template>
  <v-card outlined :loading="loading" rounded="lg">
    <v-card-text class="d-flex flex-wrap justify-space-around px-">
      <div class="text-center px-4 d-flex flex-column align-center">
        <v-skeleton-loader v-if="!report" type="image" height="22" width="50" />
        <h6 v-else class="mb-0">
          {{ (reducedReport?.IN - reducedReport?.OUT) | number }}
        </h6>
        <span class="text-caption">Público Atual</span>
      </div>
      <div class="text-center px-4 d-flex flex-column align-center">
        <v-skeleton-loader v-if="!report" type="image" height="22" width="50" />
        <h6 v-else class="mb-0">
          {{ reducedReport?.IN | number }}
        </h6>
        <span class="text-caption">Entradas</span>
      </div>
      <div class="text-center px-4 d-flex flex-column align-center">
        <v-skeleton-loader v-if="!report" type="image" height="22" width="50" />
        <h6 v-else class="mb-0">
          {{ reducedReport?.OUT | number }}
        </h6>
        <span class="text-caption">Saídas</span>
      </div>
      <div class="text-center px-4 d-flex flex-column align-center">
        <v-skeleton-loader v-if="!report" type="image" height="22" width="50" />
        <h6 v-else class="mb-0">
          {{ reducedByTicketBlock?._total | number }}
        </h6>
        <span class="text-caption">Ingressos usados</span>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Setor</th>
              <th class="text-left">Ingressos usados</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ticketGroup, index) in ticketGroups" :key="index">
              <td>{{ ticketGroup.ticketGroup.name }}</td>
              <td>{{ ticketGroup.count }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SessionEntriesDetails",
  props: {
    session: {
      type: Object,
    },
    report: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    reducedReport() {
      if (!this.report) return { IN: 0, OUT: 0 };
      return this.report?.byAction?.reduce(
        (acc, entry) => {
          const { action } = entry;
          acc[action]++;
          return acc;
        },
        { IN: 0, OUT: 0 }
      );
    },
    reducedByTicketBlock() {
      if (!this.report) return { _total: 0 };
      return this.report?.byTicketBlock?.reduce(
        (acc, entry) => {
          const { ticketBlockId } = entry;
          acc[ticketBlockId] = (acc[ticketBlockId] || 0) + entry._count;
          acc._total += entry._count;
          return acc;
        },
        {
          _total: 0,
        }
      );
    },
    ticketGroups() {
      if (!this.report) return {};
      return this.session?.TicketBlocks?.reduce((acc, ticketBlock) => {
        const ticketGroup = ticketBlock.TicketGroup;
        if (!acc[ticketGroup.id])
          acc[ticketGroup.id] = {
            ticketGroup,
            count: 0,
          };
        acc[ticketGroup.id].count +=
          this.reducedByTicketBlock[ticketBlock.id] || 0;
        return acc;
      }, {});
    },
  },
};
</script>
